import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createSetting } from '@services/settings';
import { SettingCreateInput } from '@models/setting.model';
import { toast } from 'react-toastify';
import { SETTINGS_QUERY_KEY } from './useSettings';
import { useTranslation } from '@hooks/useTranslation';

export const useCreateSetting = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: SettingCreateInput) => createSetting(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: SETTINGS_QUERY_KEY });
      toast.success(tActionMessages.settingCreatedSuccessfully);
    },
    onError: (error: any) => {
      const message = error?.response?.errors?.[0]?.message || tActionMessages.requestError;
      toast.error(message);
    },
  });
};

export default useCreateSetting;
